import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { BaseModel } from "../Generics/BaseModel"

export class Tables extends BaseModel {
  id: number

  number: number

  description: string

  hasCustomer: boolean

  isOccupied: boolean

  activeOrderCount: number

  currentPeopleCount: number

  status: EEnableStatusType

  hasActiveSelfServiceActivationCode: boolean

  isSelfServiceTabletLinked: boolean

  selfServiceLastSeenAtUtc: string

  constructor(data: Partial<Tables> = {}) {
    super()

    this.status = data.status ?? EEnableStatusType.Active

    this.id = Number(data.id ?? -1)

    this.number = data.number ?? 0

    this.description = data.description ?? ""

    this.isOccupied = data.isOccupied ?? data.hasCustomer ?? false

    this.hasCustomer = data.hasCustomer ?? this.isOccupied

    this.activeOrderCount = data.activeOrderCount ?? (this.isOccupied ? 1 : 0)

    this.currentPeopleCount = data.currentPeopleCount ?? this.activeOrderCount

    this.hasActiveSelfServiceActivationCode = data.hasActiveSelfServiceActivationCode ?? false

    this.isSelfServiceTabletLinked = data.isSelfServiceTabletLinked ?? !!data.selfServiceLastSeenAtUtc

    this.selfServiceLastSeenAtUtc = data.selfServiceLastSeenAtUtc ?? ""
  }
}
